module.exports = __webpack_public_path__ + "img/left_slide.13d846b5.svg";